<template>
  <div>
    <el-card class="">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('reportCustomManage.queryCondition') }}</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="reportCustomManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="reportCustomManageInfo.conditions.customId"
              :placeholder="$t('reportCustomManage.enterReportId')" clearable />
          </el-form-item>
          <el-form-item>
            <el-input v-model="reportCustomManageInfo.conditions.groupId"
              :placeholder="$t('reportCustomManage.enterGroupId')" clearable />
          </el-form-item>
          <el-form-item>
            <el-input v-model="reportCustomManageInfo.conditions.title"
              :placeholder="$t('reportCustomManage.enterTitle')" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryReportCustomMethod">
              <i class="el-icon-search"></i>
              {{ $t('reportCustomManage.query') }}
            </el-button>
            <el-button type="primary" size="small" @click="_resetReportCustomMethod">
              <i class="el-icon-refresh"></i>
              {{ $t('reportCustomManage.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('reportCustomManage.reportInfo') }}</span>
        <el-button type="primary" size="small" style="float: right;" @click="_openAddReportCustomModal">
          <i class="el-icon-plus"></i>
          {{ $t('reportCustomManage.addReport') }}
        </el-button>
      </div>
      <div class="ibox-content">
        <el-table :data="reportCustomManageInfo.reportCustoms" border style="width: 100%">
          <el-table-column prop="customId" :label="$t('reportCustomManage.reportId')" align="center" />
          <el-table-column prop="groupName" :label="$t('reportCustomManage.reportGroup')" align="center" />
          <el-table-column prop="title" :label="$t('reportCustomManage.title')" align="center" />
          <el-table-column prop="seq" :label="$t('reportCustomManage.sort')" align="center" />
          <el-table-column prop="remark" :label="$t('reportCustomManage.description')" align="center" />
          <el-table-column :label="$t('reportCustomManage.operation')" align="center" width="300">
            <template slot-scope="scope">
              <el-button size="mini" @click="_openCustomComponentRel(scope.row)">
                {{ $t('reportCustomManage.relateComponent') }}
              </el-button>
              <el-button size="mini" type="primary" @click="_openEditReportCustomModel(scope.row)">
                {{ $t('reportCustomManage.edit') }}
              </el-button>
              <el-button size="mini" type="danger" @click="_openDeleteReportCustomModel(scope.row)">
                {{ $t('reportCustomManage.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          layout="total, prev, pager, next" :total="reportCustomManageInfo.total"
          style="margin-top: 20px; text-align: right;" />
      </div>
    </el-card>

    <add-report-custom ref="addReportCustom" @refresh="_listReportCustoms" />
    <edit-report-custom ref="editReportCustom" @refresh="_listReportCustoms" />
    <delete-report-custom ref="deleteReportCustom" @refresh="_listReportCustoms" />
  </div>
</template>

<script>
import { listReportCustom } from '@/api/dev/reportCustomApi'
import AddReportCustom from '@/components/dev/addReportCustom/addReportCustom'
import EditReportCustom from '@/components/dev/editReportCustom/editReportCustom'
import DeleteReportCustom from '@/components/dev/deleteReportCustom/deleteReportCustom'

export default {
  name: 'ReportCustomManage',
  components: {
    AddReportCustom,
    EditReportCustom,
    DeleteReportCustom
  },
  data() {
    return {
      reportCustomManageInfo: {
        reportCustoms: [],
        total: 0,
        records: 1,
        moreCondition: false,
        customId: '',
        conditions: {
          customId: '',
          groupId: '',
          title: '',
          page: 1,
          row: 10
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listReportCustoms()
  },
  methods: {
    async _listReportCustoms() {
      try {
        const res = await listReportCustom(this.reportCustomManageInfo.conditions)
        this.reportCustomManageInfo.reportCustoms = res.data
        this.reportCustomManageInfo.total = res.total
        this.reportCustomManageInfo.records = res.records
      } catch (error) {
        console.error(error)
      }
    },
    handleCurrentChange(val) {
      this.reportCustomManageInfo.conditions.page = val
      this._listReportCustoms()
    },
    _openAddReportCustomModal() {
      this.$refs.addReportCustom.open()
    },
    _openEditReportCustomModel(row) {
      this.$refs.editReportCustom.open(row)
    },
    _openDeleteReportCustomModel(row) {
      this.$refs.deleteReportCustom.open(row)
    },
    _queryReportCustomMethod() {
      this.reportCustomManageInfo.conditions.page = 1
      this._listReportCustoms()
    },
    _resetReportCustomMethod() {
      this.reportCustomManageInfo.conditions.customId = ''
      this.reportCustomManageInfo.conditions.groupId = ''
      this.reportCustomManageInfo.conditions.title = ''
      this._listReportCustoms()
    },
    _openCustomComponentRel(row) {
      this.$router.push({
        path: '/pages/dev/reportCustomComponentRelManage',
        query: {
          customId: row.customId,
          title: row.title
        }
      })
    }
  }
}
</script>

<style scoped></style>